import React, { Component } from 'react'

const scope = 'Tag'
export default class Tag extends Component {
  render() {
    const { children } = this.props
    return (
      <div className={scope}>
        <i className='fa fa-tag' />
        {children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/tag/tag.jsx